import {
	Component,
	ContentChild,
	Input,
	OnDestroy,
	OnInit,
	TemplateRef
} from '@angular/core';
import { LoadingContainerService } from '@edassist/shared';
import { Subscription } from 'rxjs';

@Component({
	selector: 'ea-loading-container',
	templateUrl: './loading-container.component.html',
	styleUrls: ['./loading-container.component.scss']
})
export class LoadingContainerComponent implements OnInit, OnDestroy {
	@Input() loaderId: string;
	@Input() isFullPage = false;
	@Input() loading = true; // Let's default to showing, can be overridden
	// Let's give the option to have a template outlet for components that need fresh data based on a user action*/
	@ContentChild('afterLoadComponent') afterLoadComponent: TemplateRef<any>;
	private readonly subscriptions = new Subscription();

	constructor(
		private readonly loadingContainerService: LoadingContainerService
	) {}

	ngOnInit(): void {
		this.subscriptions.add(
			this.loadingContainerService.displayLoaderByIdEvent.subscribe(
				(loaderId) => {
					if (this.loaderId === loaderId) {
						this.loading = true;
					}
				}
			)
		);

		this.subscriptions.add(
			this.loadingContainerService.hideLoaderByIdEvent.subscribe((loaderId) => {
				if (this.loaderId === loaderId) {
					this.loading = false;
				}
			})
		);

		this.subscriptions.add(
			this.loadingContainerService.hideLoadersEvent.subscribe(() => {
				this.loading = false;
			})
		);

		this.subscriptions.add(
			this.loadingContainerService.displayLoaderEvent.subscribe(() => {
				this.loading = true;
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
